import { render, staticRenderFns } from "./ChatUsuarios.vue?vue&type=template&id=40f9d434"
import script from "./ChatUsuarios.vue?vue&type=script&lang=js"
export * from "./ChatUsuarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports